document.addEventListener("DOMContentLoaded", function () {
    const btns = document.querySelectorAll(".slide-scroll-btn")
    const dot_wrapper = document.querySelector(".slider-nav-wrapper")

    btns.forEach((btn) => {
        btn.addEventListener("click", function() {
            var pos = (btn.getAttribute('data-scrollTo') * 759 ) + 165
            window.scrollTo({
                top: pos,
                behavior: 'smooth'
              })
        })
    })

    window.addEventListener("scroll", (event) => {
        let scroll = window.scrollY;
        btns.forEach((btn) => {
            var pos = (btn.getAttribute('data-scrollTo') * 759 ) + 165
            if(btn.getAttribute('data-scrollTo') == 0 && scroll < (759+165)) {
                btn.classList.add("scroll-active")
            } else 
            if(scroll >= (pos) && scroll < pos + (759)) {
                btn.classList.add("scroll-active")
            } else {
                btn.classList.remove("scroll-active")
            }
        })

        if(scroll >= ((btns.length * 759))-(759)) {
            dot_wrapper.classList.add("dot-wrapper-bottom")
        } else {
            dot_wrapper.classList.remove("dot-wrapper-bottom")
        }
    });

})